const methodPatch = {
  start(source) {
    return source.start ? source.start : (startTime = 0) => source.noteOn(startTime);
  },
  stop(source) {
    return source.stop ? source.stop : (stopTime = 0) => source.noteOff(stopTime);
  },
};

export default methodPatch;
